module.exports = __webpack_public_path__ + "img/icon_map_36_on_101.c0ffe70d.png";